import React, { useState } from 'react';
import SeguimientoDashboard from './SeguimientoDashboard';
import SeguimientoClientes from './SeguimientoClientes';
import SeguimientoDetalleActivas from './SeguimientoDetalleActivas';
import ReportesCrmHome from './ReportesCrmHome';
import SeguimientoNotificacionesHome from './SeguimientoNotificacionesHome';
import SeguimientoHistorico from './SeguimientoHistorico';
import { getUsuarioActual } from '../apiAuth';

// Contenedor del módulo CRM Hipotecas: el Dashboard es la pantalla de inicio;
// el listado (antes pantalla de inicio) ahora es secundario, accesible desde
// "Acciones Rápidas" y con botón de regreso. Los sub-cuadros de "Hipotecas
// Activas" llevan a una pantalla de detalle por estatus, también con regreso.
const SeguimientoCrmHome = () => {
  const [pantalla, setPantalla] = useState('dashboard');
  const [detalleTipo, setDetalleTipo] = useState(null);
  // Histórico: el botón solo existe si la sesión trae acceso_historico (viaja
  // en el JWT; el backend lo vuelve a exigir con requireAccesoHistorico).
  const verHistorico = getUsuarioActual()?.acceso_historico === true ? () => setPantalla('historico') : undefined;

  if (pantalla === 'listado') {
    return (
      <SeguimientoClientes
        onVolverDashboard={() => setPantalla('dashboard')}
        onVerReportes={() => setPantalla('reportes')}
        onVerNotificaciones={() => setPantalla('notificaciones')}
        onVerHistorico={verHistorico}
      />
    );
  }
  if (pantalla === 'detalle-activas') {
    return (
      <SeguimientoDetalleActivas
        tipo={detalleTipo}
        onVolver={() => setPantalla('dashboard')}
      />
    );
  }
  if (pantalla === 'reportes') {
    return (
      <ReportesCrmHome
        onVolver={() => setPantalla('dashboard')}
        onVerHipotecas={() => setPantalla('listado')}
        onVerNotificaciones={() => setPantalla('notificaciones')}
        onVerHistorico={verHistorico}
      />
    );
  }
  if (pantalla === 'notificaciones') {
    return (
      <SeguimientoNotificacionesHome
        onVolver={() => setPantalla('dashboard')}
        onVerHipotecas={() => setPantalla('listado')}
        onVerReportes={() => setPantalla('reportes')}
        onVerHistorico={verHistorico}
      />
    );
  }
  if (pantalla === 'historico' && verHistorico) {
    return (
      <SeguimientoHistorico
        onVolver={() => setPantalla('dashboard')}
        onVerHipotecas={() => setPantalla('listado')}
        onVerReportes={() => setPantalla('reportes')}
        onVerNotificaciones={() => setPantalla('notificaciones')}
      />
    );
  }
  return (
    <SeguimientoDashboard
      onVerListado={() => setPantalla('listado')}
      onVerDetalleActivas={(tipo) => { setDetalleTipo(tipo); setPantalla('detalle-activas'); }}
      onVerReportes={() => setPantalla('reportes')}
      onVerNotificaciones={() => setPantalla('notificaciones')}
      onVerHistorico={verHistorico}
    />
  );
};

export default SeguimientoCrmHome;
